import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Card } from '@/components/atoms/Card/Card';
import color from '@/theme/color';

const ratingColors = color.feature.rating as Record<string, string>;

interface RatingRowEntryProps {
  area?: string;
  ratingValue?: string;
}
const RatingRowEntry = ({ area, ratingValue }: RatingRowEntryProps) => {
  const isOverall = area === 'overall';
  const ratingColor = ratingColors[ratingValue || ''] || '#cbc5b9';

  return (
    <Stack
      direction='row'
      sx={{
        p: '0.5rem',
        typography: 'bodySm',
        backgroundColor: '#faf7f3',
        borderBottom: '1px solid #000000',
        justifyContent: 'space-between',
        ...(isOverall && {
          backgroundColor: ratingColor,
          typography: 'bodyBold',
          color: '#ffffff',
        }),
      }}
    >
      <Box
        component='span'
        sx={{ m: 0, textTransform: 'capitalize', p: '0.5rem' }}
      >
        {(area && camelToSentence(area)) || 'Not assessed'}
      </Box>
      <Box
        component='span'
        sx={{
          m: 0,
          textTransform: 'capitalize',
          p: '0.5rem',
          color: 'white',
          backgroundColor: ratingValue ? ratingColor : '#cbc5b9',
          borderRadius: '1rem',
        }}
      >
        {(ratingValue && camelToSentence(ratingValue)) || 'Not assessed'}
      </Box>
    </Stack>
  );
};

interface RegulatorsRatingsProps {
  ratings: { [key: string]: string | null | undefined };
}
export const RegulatorsRatings = ({ ratings }: RegulatorsRatingsProps) => {
  const { overallRating, ...subRatings } = ratings;

  if (!overallRating || overallRating === 'notPublished') {
    return (
      <Card color='green'>
        <Box sx={{ typography: 'bodyMd' }}>
          This care provider is registered with the regulator but has not yet
          been inspected.
        </Box>
      </Card>
    );
  }

  return (
    <Card isNoPadding color='none'>
      <RatingRowEntry
        ratingValue={ratings.overallRating ?? undefined}
        area={'overall'}
      />
      {Object.entries(subRatings).map(([area, rating]) => (
        <RatingRowEntry
          key={area}
          ratingValue={rating ?? undefined}
          area={area}
        />
      ))}
    </Card>
  );
};

const camelToSentence = (str?: string) => str && str.replace(/([A-Z])/g, ' $1');

export default RegulatorsRatings;
